/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...



/* ===== Dark/Light ===== */
document.body.classList.add('body-visible');

let themeMode = document.querySelectorAll('.mode-switch__input');

if(themeMode) {
  themeMode.forEach(function(item, i) {
    item.onchange = function () {
      const body = document.body;
      body.classList.toggle('dark-theme-remove');
      if(body.classList.contains('dark-theme-remove')) {
        localStorage.setItem('theme', true);
        item.setAttribute('checked', true);
        themeMode[0].setAttribute('checked', true);
        themeMode[1].setAttribute('checked', true);
      } else {
        localStorage.setItem('theme', false);
        item.setAttribute('checked', false);
        themeMode[0].setAttribute('checked', false);
        themeMode[1].setAttribute('checked', false);
      }
    }
  })
}
const modeSwitch = localStorage.getItem('theme');
if(modeSwitch != null) {
  if(modeSwitch == 'true') {
    document.body.classList.add('dark-theme-remove');
    themeMode[0].setAttribute('checked', true);
    themeMode[1].setAttribute('checked', true);
  }
  if(modeSwitch == 'false' ){
    document.body.classList.remove('dark-theme-remove');
    themeMode[0].removeAttribute('checked');
    themeMode[1].removeAttribute('checked');
  }
}

let playVideo = document.querySelectorAll('.js-play-video');
if(playVideo) {
  playVideo.forEach(function(btn) {
    btn.onclick = () => {
      const container = btn.closest('.product-video');
      container.querySelector('.product-video__thumbs').style.display = 'none';
      container.querySelector('.product-video__video').style.display = 'block';
      container.querySelector('.product-video__video video').play();
    }
  })
}

let appTitle = document.querySelectorAll('.app-features__label');
if(appTitle) {
  appTitle.forEach(function(name) {
    name.onmouseover = () => {
      let id = name.getAttribute('data-id');
      const activeName = document.querySelector('.app-features__label.active');
      const activeContent = document.querySelector('.product-app-features__group.active');
      if(activeName) {
        activeName.classList.remove('active')
      }
      if(activeContent) {
        activeContent.classList.remove('active');
      }
      name.classList.add('active');
      document.querySelector(`#${ id }`).classList.add('active');
    };
  })
}

let modesName = document.querySelectorAll('.product-modes__menu-label');
if(modesName) {
  modesName.forEach(function(name) {
    name.onmouseover = () => {
      let id = name.getAttribute('data-id');
      const activeName = document.querySelector('.product-modes__menu-label.active');
      const activeContent = document.querySelector('.product-modes__picture.active');
      if(activeName) {
        activeName.classList.remove('active')
      }
      if(activeContent) {
        activeContent.classList.remove('active');
      }
      name.classList.add('active');
      document.querySelector(`#${ id }`).classList.add('active');
    };
  })
}

let lineItem = document.querySelectorAll('.app-features__item');

if(lineItem) {
  lineItem.forEach(function(item) {
    item.onclick = function () {
      item.classList.toggle('active');
    }
  })
}
/* ===== End - Dark/Light ===== */

/* ===== Header ===== */
class HeaderSection extends HTMLElement {
  constructor() {
    super();
    this.btnShowMenu = this.querySelector(".js-menu-mobile");
    this.menuMobile = this.querySelector(".navigation--mobile");
    this.btnCloseMenu = this.querySelector(".js-hide-menu");
    this.header = this.querySelector('.site-header');
    this.showMenuMobile();
    this.hideMenuMobile();
  }
  showMenuMobile() {
    this.btnShowMenu.addEventListener('click', () => {
      this.menuMobile.classList.add('menu--enable');
      document.documentElement.classList.add('no-scroll');
      document.body.classList.add('drawer-open'); 
    })
  }
  hideMenuMobile() {
    this.btnCloseMenu.addEventListener('click', () => {
      this.menuMobile.classList.remove('menu--enable');
      document.documentElement.classList.remove('no-scroll');
      document.body.classList.remove('drawer-open');
    })
  }
}
customElements.define('sticky-header', HeaderSection)

/* ===== End - Header ===== */

/* ===== section science ===== */
class FeatureScience extends HTMLElement {
  constructor() {
    super();

    this.tags_item = this.querySelectorAll(".tags-item");
    this.contents = this.querySelectorAll('.image-with-text');
    if(!this.contents) return;

    this.tags_item.forEach((item) => {
      item.addEventListener("click", this.clickScienceTag.bind(this));
    })
  }
  
  clickScienceTag(e) {
    const dataIndex = e.target.dataset.index;

    this.tags_item.forEach((arr_tag) => {
      arr_tag.classList.remove("item-active");
    });

    e.target.classList.add("item-active");

    this.contents.forEach((content) => {
      content.classList.remove('js-active');
    })

    this.querySelector(`.image-with-text[data-index="${dataIndex}"]`).classList.add("js-active");
  }
}
customElements.define('section-science', FeatureScience)
/* ===== End section science ===== */

/* ===== App animation & download */
class faq extends HTMLElement {
  constructor() {
    super();
    const itemIntro = this.querySelectorAll(".js-add-event");
    itemIntro.forEach((item) => {
      item.addEventListener("click", this.toggleIntroItem);
    });
  }

  toggleIntroItem() {
    const activeIntroItem = document.querySelector(".js-add-event.active");
    if (activeIntroItem && activeIntroItem !== this) {
      activeIntroItem.classList.toggle("active");
    }
    this.classList.toggle("active");
  }
}
customElements.define("faq-section", faq);
/* ===== End - App animation & download */


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData()
      .find((variant) => {
        return !variant.options.map((
          option,
          index
        ) => {
          return this.options[index] === option;
        })
          .includes(false);
      });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="SliderGallery-${ this.dataset.section }"]`);
    // mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(
    //   `${ this.dataset.section }-${ this.currentVariant.featured_media.id }`,
    //   true
    // ));
    console.log(mediaGalleries)
    const slideIndex = document.querySelector(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`).getAttribute('aria-label').split(" ").slice(0, 1);
    const swiper = document.querySelector('.js-thumbs-slider').swiper;
    swiper.slideTo(slideIndex - 1);
    const modalContent = document.querySelector(`#ProductModal-${ this.dataset.section } .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${ this.currentVariant.featured_media.id }"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${ this.dataset.url }?variant=${ this.currentVariant.id }`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${ this.dataset.section }, #product-form-installment-${ this.dataset.section }`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector("input[name=\"id\"]");
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles : true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${ this.dataset.url }?variant=${ this.currentVariant.id }&section_id=${ this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section }`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(`price-${ this.dataset.section }`);
        const source = html.getElementById(`price-${ this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section }`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${ this.dataset.section }`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(!this.currentVariant.available, 'SOLD OUT');
      });
  }

  toggleAddButton(
    disable = true,
    text,
    modifyClass = true
  ) {
    const productForm = document.getElementById(`product-form-${ this.dataset.section }`);
    if (!productForm) return;
    const addButton = productForm.querySelector("[name=\"add\"]");
    const addButtonText = productForm.querySelector("[name=\"add\"] > span");
    if (!addButton || addButton.classList.contains("product-form__submit-disabled")) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = 'RESERVE NOW FOR';
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${ this.dataset.section }`);
    const addButton = button.querySelector("[name=\"add\"]");
    const addButtonText = button.querySelector("[name=\"add\"] > span");
    const price = document.getElementById(`price-${ this.dataset.section }`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent);
    return this.variantData;
  }
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input"))
        .find((radio) => radio.checked).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);


/* ===== Blog page  ===== */
class BlogPagination extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.loadMoreItems);
  }

  loadMoreItems(){
    const urlFetch = this.dataset.href;
    fetch(urlFetch)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = new DOMParser().parseFromString(state, 'text/html');
        const getLinkNextPage = parsedState.querySelector('.blog-articles__load-more');

        document.querySelector('.blog-articles').innerHTML += parsedState.querySelector('.blog-articles').innerHTML;
        this.closest('.blog-articles__load-more').innerHTML = getLinkNextPage.innerHTML;

        const articelItem = document.querySelectorAll("[data-animate]");

        requestAnimationFrame(function() {
          articelItem.forEach((item) => {
            item.classList.add('card--reveal')
          })
        })
      });
  }
}
customElements.define("blog-pagination", BlogPagination);

/* ===== Hero video homepage ===== */
window.onload = function() {
  let backgroundVideo = document.querySelector('.hero-video__thumbs');
  let parentVideo = document.querySelector('.hero-video__video');
  let video = document.querySelector('.hero-video__video video');
  if(video) {
    video.removeAttribute('controls');
    video.muted = true;
    video.autoplay = true;
    video.loop = true;
    video.setAttribute('playsinline', true);
    setTimeout(function() {
      backgroundVideo.style.display = 'none';
      parentVideo.style.display = 'block';
      video.play();
    }, 1000);
  }
}

window.onscroll = function() {
  let logo = document.querySelectorAll('.site-header__logo');
  logo.forEach((item) => {
    item.classList.add('logo-header--scroll');
    item.classList.remove('logo-header--no-scroll');
  })
  if(window.pageYOffset === 0) {
    logo.forEach((item) => {
      item.classList.remove('logo-header--scroll');
      item.classList.add('logo-header--no-scroll');
    })
  }
}


/* ===== About page ===== */
class AboutModesSection extends HTMLElement {
  constructor() {
    super();

    this.title_item = this.querySelectorAll(".js-click-title");
    this.desc_item = this.querySelectorAll(".about--modes__desc-text");

    if(!this.desc_item) return;

    this.title_item.forEach((item) => {
      item.addEventListener("click", this.clickVariant.bind(this));
    })
  }

  clickVariant(e) {
    const dataIndex = e.target.dataset.index;

    this.title_item.forEach((arr) => {
      arr.classList.remove("active")
    })

    e.target.classList.add('active');

    this.desc_item.forEach((arr) => {
      arr.classList.remove('active');
    })

    this.querySelector(`.about--modes__desc-text[data-index="${dataIndex}"]`).classList.add("active");
  }
}
customElements.define('about-modes', AboutModesSection)